import i18n from '@/config/i18n'
import moment from 'moment'

const formatMonth: (date?: Date) => string = (date) => {
  if (!date) {
    return (
      moment().format('YYYY') +
      i18n.tc('common.year') +
      moment().format('M') +
      i18n.tc('common.month')
    )
  }
  return (
    moment(date).format('YYYY') +
    i18n.tc('common.year') +
    moment(date).format('M') +
    i18n.tc('common.month')
  )
}

export default formatMonth
